export default __webpack_public_path__ + "static/media/of_3.0d164551.mp3";